import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { useCheckFollowedWishlists } from '@pkg/hooks';

import { callGetWishlistMetadata, WISHLIST_PAGE_METADATA } from '@app/client/resources/wishlists';
import { PathParams } from '@app/routes/types';

export const useGetWishlistMetadata = (providedSlug?: string, disabled?: boolean) => {
    const followedWishlistSlug = useCheckFollowedWishlists(); // because BE no longer returns `is_follower`
    const { [PathParams.WishlistSlug]: wishlistSlug } = useParams();
    const slug = providedSlug || wishlistSlug || '';

    const cache = [WISHLIST_PAGE_METADATA, slug];

    return useQuery(
        cache,
        ({ signal }) =>
            callGetWishlistMetadata({
                slug,
                settings: {
                    signal,
                },
            }),
        {
            retry: false,
            keepPreviousData: true,
            enabled: Boolean(slug) && !disabled,
            select: (res) => {
                if (res?.ok && res.value) {
                    const isFollowing = !!followedWishlistSlug?.includes(res?.value?.slug);
                    return { ...res.value, is_follower: isFollowing };
                }
            },
        },
    );
};
